import axios from 'axios'

const ComplaintService = {
  async getList (params = {}) {
    return axios.get('admin/complaints', { params })
  },

  async show (id) {
    return axios.get(`admin/complaints/${id}`)
  },

  async updateStatus (id, data) {
    return axios.patch(`admin/complaints/${id}/status`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/complaints/${id}`)
  },

  async viewAttachment (id) {
    return axios.get(`admin/complaints/${id}/attachment`, {
      responseType: 'blob'
    })
  }
}

export default ComplaintService
